import React, { useEffect, useState } from "react";
import Orderdetails from "../Component/Orderdetails";
import "../Style/Component/Ridetrack.css";
import { useParams } from "react-router-dom";
import Riderdetails from "./Riderdetails";
import { getWithTokenAPI } from "../Util/Api";
import { useSelector } from "react-redux";

const Ridetrack = () => {
  const auth = useSelector((state) => state.auth);
  const token = auth.token;
  const { id } = useParams();
  const [ridetrack, setRideTrack] = useState({});
  useEffect(() => {
    const fetchridetrack = async () => {
      try {
        const res = await getWithTokenAPI(token, `/rider-booking/${id}`);
        setRideTrack(res?.data);
      } catch {
        console.log("Error in fetching Limit Api");
      }
    };
    fetchridetrack();
  }, [token]);
  return (
    <div className="ordertrack">
      <Orderdetails ridedetails={ridetrack} />
      <Riderdetails ridedetails={ridetrack} />
    </div>
  );
};

export default Ridetrack;
